module.exports = __webpack_public_path__ + "img/5.0f108b27.png";